module.exports = new __parcel__URL__("plus.bb4bf19d.svg").toString();